import React, { useMemo } from 'react'
import { CollapsibleSection } from '../../UI/CollapsibleSection/CollapsibleSection'
import { CreateDoorProxyModal } from '../../Modals/CompanyModal/CreateDoorProxyModal'
import { DoorsTableTabs } from './DoorsTableTabs'
import { TabbedDoorSectionProps } from './types'
import { IContactCompany } from 'models/contact_companies'
import { formatInteger } from '../../../utils/formatting'

export function TabbedDoorSection({
  forChainProxyId,
  chainID,
  chainData,
  subCategory,
  matchedTableComponent,
  matchedTableProps = {},
  matchedTableKey,
  unmatchedTableKeyPrefix,
}: TabbedDoorSectionProps) {
  // Create chainProxy object for CreateDoorProxyModal
  const chainProxy: IContactCompany | undefined = useMemo(() => {
    if (!chainData || !subCategory) return undefined

    return {
      id: forChainProxyId || chainData.contact_company_id || 0,
      domain: chainData.domain || '',
      name: chainData.name || subCategory.name,
      sub_category: subCategory,
    } as IContactCompany
  }, [chainData, subCategory, forChainProxyId])

  const totalCount = chainData?.count || 0
  const unmatchedTableKey = `${unmatchedTableKeyPrefix}-${chainData?.id}`

  return (
    <CollapsibleSection
      summary={
        <div className="flex justify-between items-center w-full">
          <div>
            Doors{' '}
            <span className="font-thin">({formatInteger(totalCount)})</span>
          </div>
          {chainProxy && (
            <CreateDoorProxyModal
              chainProxy={chainProxy}
              unmatchedTableKey={unmatchedTableKey}
            />
          )}
        </div>
      }
    >
      <DoorsTableTabs
        forChainProxyId={forChainProxyId}
        chainID={chainID}
        chainData={chainData}
        subCategory={subCategory}
        matchedTableComponent={matchedTableComponent}
        matchedTableProps={matchedTableProps}
        matchedTableKey={matchedTableKey}
        unmatchedTableKeyPrefix={unmatchedTableKeyPrefix}
      />
    </CollapsibleSection>
  )
}
